import React from 'react';
import MyProfile from '../../../subsreens/gcstaff/myProfile/MyProfile';
import TeacherMasterLayout from '../../../layouts/gcstaff/staffmasterlayout/TeacherMasterLayout';

const MyProfileScreen = () => {
    return (
        <TeacherMasterLayout>
            <MyProfile/>
        </TeacherMasterLayout>
    )
}

export default MyProfileScreen;